// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/primereact/resources/themes/lara-light-indigo/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/primeicons/primeicons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/primereact/resources/primereact.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%270.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tel-input input.form-control {
  border: none;
}
.react-tel-input input.form-control {
  background: #fff;
  border: 0;
  border-bottom: 1px solid #00000038;
  box-shadow: none;
  border-radius: 0;
  color: #000;
  font-size: 14px;
  height: auto;
  transition: all 0.5s;
  width: 100%;
}

div.react-tel-input .flag-dropdown {
  border: none;
  background-color: #fff;
  border-bottom: 1px solid #00000038;
}

.ant-table-content table tbody tr .status-data .status-active {
  background: #3fa2db;
}
.ant-table-content table tbody tr .status-data span {
  width: 10px;
  min-width: 10px;
  height: 10px;
  border-radius: 50px;
  margin-right: 10px;
  display: inline-block;
}
.ant-table-content table tbody tr .status-data .status-disabled {
  background: #e87373;
}
.ant-table-content table tbody tr .status-data .status-inactive {
  background: #f7d333;
}
div.ant-table-content table {
  font-family: 'Poppins', sans-serif;
}
div.ant-table-content table th.ant-table-cell {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  padding: 15px;
  border: 0;
  white-space: nowrap;
  background: transparent;
}
tr.ant-table-row:focus {
  border-left: 8px solid #3fa2db;
  box-shadow: 0px 0px 9.7px -1px #00000040;
}
:where(.css-dev-only-do-not-override-m4timi).ant-table-wrapper table {
  border-collapse: collapse;
}
.form-wrap > div {
  justify-content: center;
}
span.datetimepicker.no-input
  .p-inputtext.p-component.p-inputtext.p-component:focus {
  box-shadow: none;
  border: none;
}
div.p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
}
input.p-inputtext:enabled:focus {
  box-shadow: none;
}
div.p-dropdown {
  border: none;
}
.p-dropdown-trigger svg {
  color: #000;
  width: 12px;
}
.p-dropdown .p-dropdown-label.p-inputtext {
  font-size: 14px;
  padding: 0;
  font-family: 'Poppins', sans-serif;
}
.p-dropdown.p-component.p-inputwrapper {
  border-bottom: 1px solid #00000038;
  border-radius: 0;
  height: 32px;
}
div.p-dropdown-panel
  .p-dropdown-items
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #484646;
  background: #efefef;
  font-size: 14px;
}
div.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  font-size: 14px;
  color: #484646;
  padding: 8px 15px;
}
div.p-dropdown-panel {
  border: 1px solid #efefef;
  border-radius: 0;
  box-shadow: none;
  font-family: 'Poppins', sans-serif;
  background-color: #fff;
}
div.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background: #efefef;
  color: #484646;
}
.digit-group.custom-error .alert.alert-danger {
  margin-top: 15px;
}
.react-tel-input input.form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: none;
}
.react-tel-input .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.form-wrap.is-invalid div.react-tel-input .flag-dropdown {
  border-bottom: 1px solid var(--bs-form-invalid-border-color) !important;
}
div .form-control.is-invalid:focus,
div .was-validated .form-control:invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: none;
}
.is-invalid {
  border-color: #dc3545;
}
.p-dropdown.p-component.p-inputwrapper.is-invalid {
  border-color: #dc3545;
}
.otp-box input {
  width: 35px !important;
}
.otp-box {
  justify-content: center;
  display: flex;
}
div.table-pagination {
  margin: 15px 30px;
}
table.p-datatable-table tbody tr:last-child {
  border-bottom: 1px solid #e6e6e6;
}
tbody.p-datatable-tbody tr.highlight {
  border-left: 8px solid transparent;
  cursor: pointer;
}
tbody.p-datatable-tbody tr.highlight:hover {
  border-left: 8px solid #3fa2db;
  box-shadow: 0px 0px 9.7px -1px #00000040;
}
.p-datatable-emptymessage h5 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
}
div.p-datatable .p-datatable-tbody > tr {
  background: none;
}
.form-wrap.custom-form-wrap {
  margin-bottom: 0;
  width: 100%;
}
.form-wrap.custom-form-wrap div.react-tel-input .flag-dropdown {
  border: none;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
}
.edit-list ul li .form-control.is-invalid {
  border-bottom: 1px solid var(--bs-form-invalid-border-color);
}
.edit-list .p-dropdown .p-dropdown-label.p-inputtext {
  color: #000;
}
.custom-input-cls input {
  border-bottom: 1px solid #e6e6e6;
}
.edit-inner-box.custom-input-cls {
  padding-right: 50px;
}
div.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done,
div.p-datepicker.p-component.p-ripple-disabled.p-connected-overlay-enter-done {
  z-index: 9999 !important;
}
div.p-datepicker.p-component.p-ripple-disabled.p-connected-overlay-enter-done {
  min-width: 13% !important;
}
table.p-datepicker-calendar td span {
  font-size: 13px;
  font-family: 'Poppins', sans-serif;
}
td.p-datepicker-other-month {
  padding: 0;
}
tr.tablebodyrowprops td {
  padding: 0;
}
div.p-datepicker table td {
  padding: 0;
}
.p-datepicker-group-container .p-datepicker-group .p-datepicker-header {
  background: #3fa2db;
}
.p-datepicker-header button svg,
.p-datepicker-title button.p-datepicker-month,
.p-datepicker-title button.p-datepicker-year {
  color: #000;
}
div.p-datepicker {
  padding: 0;
}
div.p-datepicker table td.p-datepicker-today > span.p-highlight {
  color: #000;
  background: #3fa2db;
}
.p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,
.p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {
  color: #000;
  border-color: transparent;
  background: transparent;
}
table.p-datepicker-calendar thead tr th {
  color: #3fa2db;
}
span.p-calendar:not(.p-calendar-disabled).p-focus > .p-inputtext {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  /* border-color:; */
}
.schedule-datepicker.p-calendar.p-component.p-inputwrapper input {
  padding: 10px 15px;
  background: #f6f6f6;
  border: 1px solid #f6f6f6;
  color: #000;
  font-size: 14px;
  border-radius: 0;
}
.schedule-datepicker.p-calendar.p-component.p-inputwrapper {
  width: 100%;
}
.schedule-modal-form
  .schedule-datepicker.p-calendar.p-component.p-inputwrapper {
  width: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.schedule-modal-form .p-calendar .p-datepicker {
  min-width: inherit;
}
.modal-dropdown.p-dropdown.p-component.p-inputwrapper {
  border: 1px solid #f6f6f6;
  border-bottom: 1px solid #f6f6f6;
  background: #f6f6f6;
  height: 40px;
}
.modal-dropdown.p-dropdown .p-dropdown-label.p-inputtext {
  color: #898989;
}
.modal-dropdown span.p-dropdown-label.p-inputtext {
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.schedule-modal-form .p-disabled,
.schedule-modal-form .p-disabled * {
  background: #f1f1f2 !important;
}
.p-dropdown-filter-container input {
  height: 35px;
}
.p-dropdown-filter-container svg {
  width: 14px;
}
input.p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #d1d5db;
}
input.p-inputtext:enabled:hover {
  border-color: #d1d5db;
}
li.p-dropdown-empty-message {
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
}
.p-dropdown-filter-container .p-dropdown-filter.p-inputtext.p-component {
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
}
.patient-reg-select.p-dropdown.p-component.p-inputwrapper {
  height: 26px;
}
.p-dropdown.p-component.p-inputwrapper .p-dropdown-label.p-inputtext {
  font-family: 'Poppins', sans-serif;
  color: #000;
}
.p-dropdown .p-dropdown-label.p-placeholder {
  color: #898989 !important;
}
.fc .fc-view-harness-active > .fc-view {
  background: #fff;
}
div.fc-toolbar-chunk button.fc-today-button {
  display: none;
}
div.fc .fc-toolbar {
  align-items: center;
  display: flex;
  justify-content: center;
}
div.fc .fc-button-primary {
  background-color: transparent;
  border-color: transparent;
  color: #000;
}
.fc-toolbar-chunk h2.fc-toolbar-title {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #3fa2db;
}
.fc-button-group span.fc-icon {
  color: #000;
}
div.fc .fc-button-primary:hover {
  color: #000;
}
div.fc .fc-button-primary:focus {
  box-shadow: none;
}
div.fc .fc-button-primary:not(:disabled).fc-button-active:focus,
div.fc .fc-button-primary:not(:disabled):active:focus {
  box-shadow: none;
}
div.fc .fc-button-primary:not(:disabled).fc-button-active,
div.fc .fc-button-primary:not(:disabled):active {
  background-color: #fff;
  border-color: #fff;
  color: #000;
}
.fc-daygrid-event-dot,
.fc-event-time {
  display: none;
}
.flag-dropdown div.selected-flag {
  padding-left: 0;
}
.react-tel-input .country-list .country {
  margin-bottom: 0;
}
.fc .fc-daygrid-day-top {
  flex-direction: column;
}
.fc .fc-daygrid-day.fc-day-today .fc-daygrid-dot-event .fc-event-title {
  color: #fff;
}
.fc-daygrid-dot-event .fc-event-title {
  font-size: 14px;
  font-weight: 500;
  margin: 0 5px;
}
.calendar-btn-info {
  position: relative;
  text-align: right;
}
.calendar-btn {
  position: absolute;
  right: 0;
}
.calendar-btn .btn {
  color: #000;
  padding: 10px 40px;
}
.main-wrapper.slide-nav .bar-icon span:first-child {
  position: relative;
  top: 9px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.main-wrapper.slide-nav .bar-icon span:nth-child(2) {
  display: none;
}
.main-wrapper.slide-nav .bar-icon span:last-child {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
}
.no-kiosk {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
}
.edit-details-disable .edit-grid .no-kiosk {
  color: #b4b4b4;
}
.edit-box {
  position: relative;
}
div.edit-header ul li p span.status-inactive {
  background: #f7d333;
}
div.edit-header ul li p span.status-disabled {
  background: #e87373;
}
.loaderInitialHeight {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loaderInitial {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
}
.loaderInitial::before,
.loaderInitial::after {
  content: '';
  grid-area: 1/1;
  --c: no-repeat radial-gradient(farthest-side, #25b09b 92%, #0000);
  background:
    var(--c) 50% 0,
    var(--c) 50% 100%,
    var(--c) 100% 50%,
    var(--c) 0 50%;
  background-size: 12px 12px;
  animation: l12 1s infinite;
}
.loaderInitial::before {
  margin: 4px;
  filter: hue-rotate(45deg);
  background-size: 8px 8px;
  animation-timing-function: linear;
}

@keyframes l12 {
  100% {
    transform: rotate(0.5turn);
  }
}
.custom-checkbox-line {
  line-height: normal;
}
.schedule-modal-form div.p-dropdown .p-dropdown-trigger {
  position: relative;
  right: 10px;
}
div.p-dropdown .p-dropdown-trigger {
  width: 1rem;
}
.stickybar {
  position: sticky;
  top: 0;
}
.re-associate-nav li span {
  color: #3fa2db;
}

.p-datatable .p-datatable-footer {
  padding: 0 !important;
  border-radius: 1rem !important;
}
.highlight-date {
  background-color: #3fa2db !important;
  color: white !important;
}
.scheduled-slot-datepicker input {
  padding: 10px 15px;
  height: 36px;
  border-radius: 7px;
  border: 1px solid #3fa2db;
}
.scheduled-slot-datepicker input::placeholder {
  font-size: 14px;
}
.react-box-right {
  margin-right: 5px;
}

.p-datepicker-hidden {
  display: none;
}
.p-datepicker-visible {
  display: block;
}
div.fc .fc-button-primary:hover {
  background-color: transparent;
}
.cal-select {
  position: absolute;
  left: 0;
  width: 100%;
}
.cal-select-main {
  position: relative;
  width: 130px;
}
.cal-select .p-dropdown.p-component.p-inputwrapper {
  background-color: transparent;
}
.cal-select .p-dropdown-label.p-inputtext {
  display: flex;
  align-items: center;
}
.fc-button-group button.fc-prev-button.fc-button {
  left: -30px;
  position: absolute;
  top: -4px;
  padding: 0;
}
.fc-button-group button.fc-next-button.fc-button {
  right: -30px;
  position: absolute;
  top: -4px;
  padding: 0;
}
div.fc .fc-button-group {
  position: unset;
}
div.fc-header-toolbar.fc-toolbar {
  display: inline;
  margin: auto;
  position: relative;
}
ul.custom-ul-react {
  list-style: inside;
}
div.fc .fc-button-primary:hover {
  color: #000;
  background: #fff;
  border: 1px solid transparent;
}
.symptoms-input-control .form-control {
  height: auto;
}
.symptoms-input input {
  padding: 0;
  border: 0;
}
.symptoms-input input::placeholder {
  color: #898989;
}
.symptoms-save .btn {
  padding: 6px 24px;
}
.symptoms-select .p-dropdown.p-component.p-inputwrapper {
  background: #e6e6e6;
  border: 1px solid #e6e6e6;
  border-radius: 30px;
  height: 34px;
  padding: 10px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.investigation-input-control input {
  padding: 0;
  border: 0;
}
.refer-select-info .symptoms-select .p-dropdown.p-component.p-inputwrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  height: 34px;
  padding: 10px 15px 10px 10px;
}
.refer-select-info .symptoms-select div.p-dropdown .p-dropdown-trigger {
  position: relative;
  right: -10px;
}
.video-container {
  width: auto;
  height: 100%;
  position: relative;
  border-radius: 15px;
}
.subscriber-video-item {
  height: 100%;
}
.subscriber-video-item .OT_subscriber {
  border-radius: 16px;
  margin-bottom: 20px;
}
.subscriber-small-video {
  width: 110px;
  height: 160px;
  position: absolute;
  top: 20px;
  right: 20px;
  border-radius: 16px;
}
.subscriber-small-video-two {
  width: 110px;
  height: 160px;
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 16px;
}
#publisher.video-item {
  position: absolute;
  z-index: 1;
  top: 20px;
  left: 20px;
  width: 110px;
  height: 160px;
  border-radius: 20px;
  background-color: #000;
}
.OT_subscriber {
  min-width: 100% !important;
  min-height: 100% !important;
}
.video-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #E8E8E8;
  position: relative;
  border-radius: 15px;
}
.subscriber-video-item {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}
.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #000;
}

.video-item {
  width: 200px;
  height: 150px;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.subscriber-video-item {
  transition: all 0.3s ease;
  overflow: hidden;
}

.subscriber-video-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.video-btn {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 24px 20px;
}
.video-btn.w-70{
width: 70%;
}
.video-btn .nav li {
  margin-right: 20px;
}
.video-btn .nav li:last-child {
  margin-right: 0;
}
.video-btn .btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 50px;
  min-height: 50px;
  height: 50px;
  padding: 0;
  border: 0;
  border-radius: 50px;
  font-size: 16px;
  color: #00568E;
  background: #FFF;
}
.video-btn .btn:hover {
  border: 0;
  background: #d8d8d8;
}
.video-btn .btn:active {
  border: 0;
  background: #d8d8d8 !important;
}
.video-btn .btn img {
  width: 24px;
}
.video-btn-bottom {
  margin-top: 30px;
}
.video-btn-bottom .nav {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.video-btn .btn-end-call {
  color: #FFF;
  background: #E87373;
}
.video-btn .btn-end-call:hover {
  background: #ad3434;
}
.video-btn .btn-end-call:active {
  border: 0;
  background: #ad3434 !important;
}
.incoming-call-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  border-radius: 15px;
  background: white;
  padding: 20px 20px 15px;
  border: 1px solid #ccc;
  z-index: 1000;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.incoming-call-notification .btn {
  font-size: 14px;
  padding: 6px 24px;
  margin: 5px;
}
.vitals-play-grid {
  background: #CCCCCC;
  border-radius: 30px;
  width: 200px;
  padding: 5px 15px;
}
.vitals-play-grid .nav {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.vitals-play-grid .nav li {
  display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
  margin-right: 10px;
}
.vitals-play-grid .nav li:last-child {
  margin-right: 0;
}
.vitals-play-grid .nav li a {
  color: #000;
}
.vitals-play-grid .nav li a::after {
  display: none;
}
.vitals-play-grid .nav li p {
  font-size: 14px;
  background: transparent;
  border-radius: 0;
  padding: 0;
  margin-bottom: 0;
}
.vitals-play-grid .nav li .play-bar {
  width: 75px;
  height: 3px;
  border-radius: 30px;
  background: #000;
  display: inline-block;
}
.p-hour-picker .p-link {
  font-size: 14px;
}
.p-minute-picker .p-link {
  font-size: 14px;
}
.p-datepicker .p-timepicker span {
  font-size: 14px;
  color: #000;
}
.scrollable-div {
  overflow-y: scroll;
  width: 100%;
}
.circular-progress {
  position: relative;
  width: 105px;
  height: 105px;
}
.circular-progress svg {
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
}
.circular-progress circle {
  fill: none;
  stroke-width: 4px;
}
.circular-progress .bg {
  stroke: #e6e6e6;
}
.circular-progress .progress {
  stroke: #007bff;
  stroke-linecap: round;
  stroke-dasharray: 307;
  stroke-dashoffset: 307;
  transition: stroke-dashoffset 0.5s ease;
}
.circular-progress .percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16.8px;
  font-weight: bold;
}
.checkduration .form-check input {
  cursor: pointer;
}
.prescription-details-info .prescription-info {
  width: 28%;
}
.join-body {
  overflow: hidden;
}
.join-scroll-right {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px;
}
.join-body .modal-backdrop {
  background-color: #0000001c;
}
.prescription-form-top {
  margin-top: 24px;
}
.screenshot-details .prescription_preview_btn {
  padding: 6px 24px;
  color: #FFF;
}
.screenshot-details .prescription_preview_btn:hover {
  color: #3FA2DB;
}
.screenshot-details .prescription_preview_btn:after {
  display: none;
}
.iframe-btn .btn {
  padding: 6px 24px;
}
.patient-nav-list .nav li:nth-child(5) {
  border: 0;
}
.patient-nav-list .nav li:last-child {
  margin-left: auto;
}
.pacs-modal-body .pacs-img img {
  width: 100%;
}
.vitals-head {
    margin-bottom: 15px;
}
.vitals-body-info {
    padding-left: 40px;
    padding-right: 15px;
}
.vitals-body-info hr {
  opacity: 1;
  border-top: 1px solid #E6E6E6;
}
.card .vitals-patient-card-body {
	padding: 30px 30px 20px;
}
.vitals-patient-list .nav {
	-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
}
.vitals-patient-list .nav li {
	font-weight: 300;
	margin-bottom: 10px;
	margin-right: 50px;
}
.vitals-patient-list .nav li:last-child {
	margin-right: 0;
}
.vitals-patient-list .nav li span {
	font-weight: 500;
	margin-right: 5px;
}
.card.vitals-video-card {
	background: #E8E8E8;
}
.doctor-header.vitals-doctor-header {
	padding-top: 0;
	padding-bottom: 5px;
}
.prescription-table.prescription-table-info {
	margin-bottom: 0;
}
.prescription-table.prescription-table-info .table thead tr th {
	text-align: left;
}
.prescription-table.prescription-table-info .table thead tr th:first-child {
	padding-left: 15px;
}
.prescription-table.prescription-table-infos .table tbody tr {
  border-bottom: 0;;
}
.prescription-table.prescription-table-info .table tbody tr td {
	color: #000;
	text-align: left;
}
.prescription-table.prescription-table-info .table tbody tr td:first-child {
	padding-left: 15px;
}
.press-btn {
	margin-bottom: 24px;
}
.press-btn .btn {
	padding: 8px 24px;
}

@media (max-width: 1599.98px) {
  .calendar-btn .btn {
    padding: 7px 30px;
  }
}
@media (max-width: 1199.98px) {
  .video-container {
    height: 500px;
  }
}
@media (max-width: 575.98px) {
  .calendar-btn {
    padding-bottom: 10px;
    position: relative;
  }
}


.video-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.main-screen {
  width: 100%;
  height: 100%;
}

.small-video-wrapper {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
}

.small-screen {
  width: 150px;
  height: 100px;
  border: 1px solid #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAKA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;AACd;AACA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,oCAAoC;EACpC,yDAA6U;EAC7U,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;AACA;EACE,uEAAuE;AACzE;AACA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;AACA;;EAEE,WAAW;EACX,cAAc;EACd,iEAAiE;EACjE;;;;kBAIgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;AACpB;AACA;AACA,UAAU;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,2BAA2B;CAC5B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;CACC,uBAAuB;AACxB;AACA;CACC,yBAAyB;IACtB,sBAAsB;IACtB,mBAAmB;CACtB,eAAe;CACf,uBAAuB;AACxB;AACA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["@import 'primereact/resources/themes/lara-light-indigo/theme.css';\r\n@import 'primeicons/primeicons.css';\r\n@import 'primereact/resources/primereact.css';\r\n@import 'primereact/resources/themes/lara-light-indigo/theme.css';\r\n\r\n.react-tel-input input.form-control {\r\n  border: none;\r\n}\r\n.react-tel-input input.form-control {\r\n  background: #fff;\r\n  border: 0;\r\n  border-bottom: 1px solid #00000038;\r\n  box-shadow: none;\r\n  border-radius: 0;\r\n  color: #000;\r\n  font-size: 14px;\r\n  height: auto;\r\n  transition: all 0.5s;\r\n  width: 100%;\r\n}\r\n\r\ndiv.react-tel-input .flag-dropdown {\r\n  border: none;\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #00000038;\r\n}\r\n\r\n.ant-table-content table tbody tr .status-data .status-active {\r\n  background: #3fa2db;\r\n}\r\n.ant-table-content table tbody tr .status-data span {\r\n  width: 10px;\r\n  min-width: 10px;\r\n  height: 10px;\r\n  border-radius: 50px;\r\n  margin-right: 10px;\r\n  display: inline-block;\r\n}\r\n.ant-table-content table tbody tr .status-data .status-disabled {\r\n  background: #e87373;\r\n}\r\n.ant-table-content table tbody tr .status-data .status-inactive {\r\n  background: #f7d333;\r\n}\r\ndiv.ant-table-content table {\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\ndiv.ant-table-content table th.ant-table-cell {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #000;\r\n  padding: 15px;\r\n  border: 0;\r\n  white-space: nowrap;\r\n  background: transparent;\r\n}\r\ntr.ant-table-row:focus {\r\n  border-left: 8px solid #3fa2db;\r\n  box-shadow: 0px 0px 9.7px -1px #00000040;\r\n}\r\n:where(.css-dev-only-do-not-override-m4timi).ant-table-wrapper table {\r\n  border-collapse: collapse;\r\n}\r\n.form-wrap > div {\r\n  justify-content: center;\r\n}\r\nspan.datetimepicker.no-input\r\n  .p-inputtext.p-component.p-inputtext.p-component:focus {\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\ndiv.p-dropdown:not(.p-disabled).p-focus {\r\n  box-shadow: none;\r\n}\r\ninput.p-inputtext:enabled:focus {\r\n  box-shadow: none;\r\n}\r\ndiv.p-dropdown {\r\n  border: none;\r\n}\r\n.p-dropdown-trigger svg {\r\n  color: #000;\r\n  width: 12px;\r\n}\r\n.p-dropdown .p-dropdown-label.p-inputtext {\r\n  font-size: 14px;\r\n  padding: 0;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n.p-dropdown.p-component.p-inputwrapper {\r\n  border-bottom: 1px solid #00000038;\r\n  border-radius: 0;\r\n  height: 32px;\r\n}\r\ndiv.p-dropdown-panel\r\n  .p-dropdown-items\r\n  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {\r\n  color: #484646;\r\n  background: #efefef;\r\n  font-size: 14px;\r\n}\r\ndiv.p-dropdown-panel .p-dropdown-items .p-dropdown-item {\r\n  font-size: 14px;\r\n  color: #484646;\r\n  padding: 8px 15px;\r\n}\r\ndiv.p-dropdown-panel {\r\n  border: 1px solid #efefef;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  font-family: 'Poppins', sans-serif;\r\n  background-color: #fff;\r\n}\r\ndiv.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\r\n  background: #efefef;\r\n  color: #484646;\r\n}\r\n.digit-group.custom-error .alert.alert-danger {\r\n  margin-top: 15px;\r\n}\r\n.react-tel-input input.form-control.is-invalid:focus {\r\n  border-color: var(--bs-form-invalid-border-color);\r\n  box-shadow: none;\r\n}\r\n.react-tel-input .form-control.is-invalid {\r\n  border-color: var(--bs-form-invalid-border-color);\r\n  padding-right: calc(1.5em + 0.75rem);\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='0.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\r\n  background-repeat: no-repeat;\r\n  background-position: right calc(0.375em + 0.1875rem) center;\r\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n}\r\n.form-wrap.is-invalid div.react-tel-input .flag-dropdown {\r\n  border-bottom: 1px solid var(--bs-form-invalid-border-color) !important;\r\n}\r\ndiv .form-control.is-invalid:focus,\r\ndiv .was-validated .form-control:invalid:focus {\r\n  border-color: var(--bs-form-invalid-border-color);\r\n  box-shadow: none;\r\n}\r\n.is-invalid {\r\n  border-color: #dc3545;\r\n}\r\n.p-dropdown.p-component.p-inputwrapper.is-invalid {\r\n  border-color: #dc3545;\r\n}\r\n.otp-box input {\r\n  width: 35px !important;\r\n}\r\n.otp-box {\r\n  justify-content: center;\r\n  display: flex;\r\n}\r\ndiv.table-pagination {\r\n  margin: 15px 30px;\r\n}\r\ntable.p-datatable-table tbody tr:last-child {\r\n  border-bottom: 1px solid #e6e6e6;\r\n}\r\ntbody.p-datatable-tbody tr.highlight {\r\n  border-left: 8px solid transparent;\r\n  cursor: pointer;\r\n}\r\ntbody.p-datatable-tbody tr.highlight:hover {\r\n  border-left: 8px solid #3fa2db;\r\n  box-shadow: 0px 0px 9.7px -1px #00000040;\r\n}\r\n.p-datatable-emptymessage h5 {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  margin-bottom: 0;\r\n}\r\n.loading {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 999999;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(255, 255, 255, 0.9);\r\n}\r\ndiv.p-datatable .p-datatable-tbody > tr {\r\n  background: none;\r\n}\r\n.form-wrap.custom-form-wrap {\r\n  margin-bottom: 0;\r\n  width: 100%;\r\n}\r\n.form-wrap.custom-form-wrap div.react-tel-input .flag-dropdown {\r\n  border: none;\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #e6e6e6;\r\n}\r\n.edit-list ul li .form-control.is-invalid {\r\n  border-bottom: 1px solid var(--bs-form-invalid-border-color);\r\n}\r\n.edit-list .p-dropdown .p-dropdown-label.p-inputtext {\r\n  color: #000;\r\n}\r\n.custom-input-cls input {\r\n  border-bottom: 1px solid #e6e6e6;\r\n}\r\n.edit-inner-box.custom-input-cls {\r\n  padding-right: 50px;\r\n}\r\ndiv.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done,\r\ndiv.p-datepicker.p-component.p-ripple-disabled.p-connected-overlay-enter-done {\r\n  z-index: 9999 !important;\r\n}\r\ndiv.p-datepicker.p-component.p-ripple-disabled.p-connected-overlay-enter-done {\r\n  min-width: 13% !important;\r\n}\r\ntable.p-datepicker-calendar td span {\r\n  font-size: 13px;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\ntd.p-datepicker-other-month {\r\n  padding: 0;\r\n}\r\ntr.tablebodyrowprops td {\r\n  padding: 0;\r\n}\r\ndiv.p-datepicker table td {\r\n  padding: 0;\r\n}\r\n.p-datepicker-group-container .p-datepicker-group .p-datepicker-header {\r\n  background: #3fa2db;\r\n}\r\n.p-datepicker-header button svg,\r\n.p-datepicker-title button.p-datepicker-month,\r\n.p-datepicker-title button.p-datepicker-year {\r\n  color: #000;\r\n}\r\ndiv.p-datepicker {\r\n  padding: 0;\r\n}\r\ndiv.p-datepicker table td.p-datepicker-today > span.p-highlight {\r\n  color: #000;\r\n  background: #3fa2db;\r\n}\r\n.p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,\r\n.p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {\r\n  color: #000;\r\n  border-color: transparent;\r\n  background: transparent;\r\n}\r\ntable.p-datepicker-calendar thead tr th {\r\n  color: #3fa2db;\r\n}\r\nspan.p-calendar:not(.p-calendar-disabled).p-focus > .p-inputtext {\r\n  outline: 0 none;\r\n  outline-offset: 0;\r\n  box-shadow: none;\r\n  /* border-color:; */\r\n}\r\n.schedule-datepicker.p-calendar.p-component.p-inputwrapper input {\r\n  padding: 10px 15px;\r\n  background: #f6f6f6;\r\n  border: 1px solid #f6f6f6;\r\n  color: #000;\r\n  font-size: 14px;\r\n  border-radius: 0;\r\n}\r\n.schedule-datepicker.p-calendar.p-component.p-inputwrapper {\r\n  width: 100%;\r\n}\r\n.schedule-modal-form\r\n  .schedule-datepicker.p-calendar.p-component.p-inputwrapper {\r\n  width: auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n}\r\n.schedule-modal-form .p-calendar .p-datepicker {\r\n  min-width: inherit;\r\n}\r\n.modal-dropdown.p-dropdown.p-component.p-inputwrapper {\r\n  border: 1px solid #f6f6f6;\r\n  border-bottom: 1px solid #f6f6f6;\r\n  background: #f6f6f6;\r\n  height: 40px;\r\n}\r\n.modal-dropdown.p-dropdown .p-dropdown-label.p-inputtext {\r\n  color: #898989;\r\n}\r\n.modal-dropdown span.p-dropdown-label.p-inputtext {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 15px;\r\n}\r\n.schedule-modal-form .p-disabled,\r\n.schedule-modal-form .p-disabled * {\r\n  background: #f1f1f2 !important;\r\n}\r\n.p-dropdown-filter-container input {\r\n  height: 35px;\r\n}\r\n.p-dropdown-filter-container svg {\r\n  width: 14px;\r\n}\r\ninput.p-inputtext:enabled:focus {\r\n  box-shadow: none;\r\n  border-color: #d1d5db;\r\n}\r\ninput.p-inputtext:enabled:hover {\r\n  border-color: #d1d5db;\r\n}\r\nli.p-dropdown-empty-message {\r\n  font-size: 14px;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n.p-dropdown-filter-container .p-dropdown-filter.p-inputtext.p-component {\r\n  font-size: 14px;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n.patient-reg-select.p-dropdown.p-component.p-inputwrapper {\r\n  height: 26px;\r\n}\r\n.p-dropdown.p-component.p-inputwrapper .p-dropdown-label.p-inputtext {\r\n  font-family: 'Poppins', sans-serif;\r\n  color: #000;\r\n}\r\n.p-dropdown .p-dropdown-label.p-placeholder {\r\n  color: #898989 !important;\r\n}\r\n.fc .fc-view-harness-active > .fc-view {\r\n  background: #fff;\r\n}\r\ndiv.fc-toolbar-chunk button.fc-today-button {\r\n  display: none;\r\n}\r\ndiv.fc .fc-toolbar {\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\ndiv.fc .fc-button-primary {\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n  color: #000;\r\n}\r\n.fc-toolbar-chunk h2.fc-toolbar-title {\r\n  font-family: 'Poppins', sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #3fa2db;\r\n}\r\n.fc-button-group span.fc-icon {\r\n  color: #000;\r\n}\r\ndiv.fc .fc-button-primary:hover {\r\n  color: #000;\r\n}\r\ndiv.fc .fc-button-primary:focus {\r\n  box-shadow: none;\r\n}\r\ndiv.fc .fc-button-primary:not(:disabled).fc-button-active:focus,\r\ndiv.fc .fc-button-primary:not(:disabled):active:focus {\r\n  box-shadow: none;\r\n}\r\ndiv.fc .fc-button-primary:not(:disabled).fc-button-active,\r\ndiv.fc .fc-button-primary:not(:disabled):active {\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n  color: #000;\r\n}\r\n.fc-daygrid-event-dot,\r\n.fc-event-time {\r\n  display: none;\r\n}\r\n.flag-dropdown div.selected-flag {\r\n  padding-left: 0;\r\n}\r\n.react-tel-input .country-list .country {\r\n  margin-bottom: 0;\r\n}\r\n.fc .fc-daygrid-day-top {\r\n  flex-direction: column;\r\n}\r\n.fc .fc-daygrid-day.fc-day-today .fc-daygrid-dot-event .fc-event-title {\r\n  color: #fff;\r\n}\r\n.fc-daygrid-dot-event .fc-event-title {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin: 0 5px;\r\n}\r\n.calendar-btn-info {\r\n  position: relative;\r\n  text-align: right;\r\n}\r\n.calendar-btn {\r\n  position: absolute;\r\n  right: 0;\r\n}\r\n.calendar-btn .btn {\r\n  color: #000;\r\n  padding: 10px 40px;\r\n}\r\n.main-wrapper.slide-nav .bar-icon span:first-child {\r\n  position: relative;\r\n  top: 9px;\r\n  transform: rotate(45deg);\r\n  -webkit-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n}\r\n.main-wrapper.slide-nav .bar-icon span:nth-child(2) {\r\n  display: none;\r\n}\r\n.main-wrapper.slide-nav .bar-icon span:last-child {\r\n  transform: rotate(135deg);\r\n  -webkit-transform: rotate(135deg);\r\n  -ms-transform: rotate(135deg);\r\n}\r\n.no-kiosk {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  color: #000;\r\n}\r\n.edit-details-disable .edit-grid .no-kiosk {\r\n  color: #b4b4b4;\r\n}\r\n.edit-box {\r\n  position: relative;\r\n}\r\ndiv.edit-header ul li p span.status-inactive {\r\n  background: #f7d333;\r\n}\r\ndiv.edit-header ul li p span.status-disabled {\r\n  background: #e87373;\r\n}\r\n.loaderInitialHeight {\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n.loaderInitial {\r\n  width: 50px;\r\n  aspect-ratio: 1;\r\n  display: grid;\r\n}\r\n.loaderInitial::before,\r\n.loaderInitial::after {\r\n  content: '';\r\n  grid-area: 1/1;\r\n  --c: no-repeat radial-gradient(farthest-side, #25b09b 92%, #0000);\r\n  background:\r\n    var(--c) 50% 0,\r\n    var(--c) 50% 100%,\r\n    var(--c) 100% 50%,\r\n    var(--c) 0 50%;\r\n  background-size: 12px 12px;\r\n  animation: l12 1s infinite;\r\n}\r\n.loaderInitial::before {\r\n  margin: 4px;\r\n  filter: hue-rotate(45deg);\r\n  background-size: 8px 8px;\r\n  animation-timing-function: linear;\r\n}\r\n\r\n@keyframes l12 {\r\n  100% {\r\n    transform: rotate(0.5turn);\r\n  }\r\n}\r\n.custom-checkbox-line {\r\n  line-height: normal;\r\n}\r\n.schedule-modal-form div.p-dropdown .p-dropdown-trigger {\r\n  position: relative;\r\n  right: 10px;\r\n}\r\ndiv.p-dropdown .p-dropdown-trigger {\r\n  width: 1rem;\r\n}\r\n.stickybar {\r\n  position: sticky;\r\n  top: 0;\r\n}\r\n.re-associate-nav li span {\r\n  color: #3fa2db;\r\n}\r\n\r\n.p-datatable .p-datatable-footer {\r\n  padding: 0 !important;\r\n  border-radius: 1rem !important;\r\n}\r\n.highlight-date {\r\n  background-color: #3fa2db !important;\r\n  color: white !important;\r\n}\r\n.scheduled-slot-datepicker input {\r\n  padding: 10px 15px;\r\n  height: 36px;\r\n  border-radius: 7px;\r\n  border: 1px solid #3fa2db;\r\n}\r\n.scheduled-slot-datepicker input::placeholder {\r\n  font-size: 14px;\r\n}\r\n.react-box-right {\r\n  margin-right: 5px;\r\n}\r\n\r\n.p-datepicker-hidden {\r\n  display: none;\r\n}\r\n.p-datepicker-visible {\r\n  display: block;\r\n}\r\ndiv.fc .fc-button-primary:hover {\r\n  background-color: transparent;\r\n}\r\n.cal-select {\r\n  position: absolute;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n.cal-select-main {\r\n  position: relative;\r\n  width: 130px;\r\n}\r\n.cal-select .p-dropdown.p-component.p-inputwrapper {\r\n  background-color: transparent;\r\n}\r\n.cal-select .p-dropdown-label.p-inputtext {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.fc-button-group button.fc-prev-button.fc-button {\r\n  left: -30px;\r\n  position: absolute;\r\n  top: -4px;\r\n  padding: 0;\r\n}\r\n.fc-button-group button.fc-next-button.fc-button {\r\n  right: -30px;\r\n  position: absolute;\r\n  top: -4px;\r\n  padding: 0;\r\n}\r\ndiv.fc .fc-button-group {\r\n  position: unset;\r\n}\r\ndiv.fc-header-toolbar.fc-toolbar {\r\n  display: inline;\r\n  margin: auto;\r\n  position: relative;\r\n}\r\nul.custom-ul-react {\r\n  list-style: inside;\r\n}\r\ndiv.fc .fc-button-primary:hover {\r\n  color: #000;\r\n  background: #fff;\r\n  border: 1px solid transparent;\r\n}\r\n.symptoms-input-control .form-control {\r\n  height: auto;\r\n}\r\n.symptoms-input input {\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n.symptoms-input input::placeholder {\r\n  color: #898989;\r\n}\r\n.symptoms-save .btn {\r\n  padding: 6px 24px;\r\n}\r\n.symptoms-select .p-dropdown.p-component.p-inputwrapper {\r\n  background: #e6e6e6;\r\n  border: 1px solid #e6e6e6;\r\n  border-radius: 30px;\r\n  height: 34px;\r\n  padding: 10px;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n.investigation-input-control input {\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n.refer-select-info .symptoms-select .p-dropdown.p-component.p-inputwrapper {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  background: #fff;\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 5px;\r\n  height: 34px;\r\n  padding: 10px 15px 10px 10px;\r\n}\r\n.refer-select-info .symptoms-select div.p-dropdown .p-dropdown-trigger {\r\n  position: relative;\r\n  right: -10px;\r\n}\r\n.video-container {\r\n  width: auto;\r\n  height: 100%;\r\n  position: relative;\r\n  border-radius: 15px;\r\n}\r\n.subscriber-video-item {\r\n  height: 100%;\r\n}\r\n.subscriber-video-item .OT_subscriber {\r\n  border-radius: 16px;\r\n  margin-bottom: 20px;\r\n}\r\n.subscriber-small-video {\r\n  width: 110px;\r\n  height: 160px;\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  border-radius: 16px;\r\n}\r\n.subscriber-small-video-two {\r\n  width: 110px;\r\n  height: 160px;\r\n  position: absolute;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  border-radius: 16px;\r\n}\r\n#publisher.video-item {\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 20px;\r\n  left: 20px;\r\n  width: 110px;\r\n  height: 160px;\r\n  border-radius: 20px;\r\n  background-color: #000;\r\n}\r\n.OT_subscriber {\r\n  min-width: 100% !important;\r\n  min-height: 100% !important;\r\n}\r\n.video-item {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  background-color: #E8E8E8;\r\n  position: relative;\r\n  border-radius: 15px;\r\n}\r\n.subscriber-video-item {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 1rem;\r\n}\r\n.video-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: #000;\r\n}\r\n\r\n.video-item {\r\n  width: 200px;\r\n  height: 150px;\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  z-index: 2;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.subscriber-video-item {\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.subscriber-video-item video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n.video-btn {\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 24px 20px;\r\n}\r\n.video-btn.w-70{\r\nwidth: 70%;\r\n}\r\n.video-btn .nav li {\r\n  margin-right: 20px;\r\n}\r\n.video-btn .nav li:last-child {\r\n  margin-right: 0;\r\n}\r\n.video-btn .btn {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  align-items: center;\r\n  justify-content: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  width: 50px;\r\n  min-height: 50px;\r\n  height: 50px;\r\n  padding: 0;\r\n  border: 0;\r\n  border-radius: 50px;\r\n  font-size: 16px;\r\n  color: #00568E;\r\n  background: #FFF;\r\n}\r\n.video-btn .btn:hover {\r\n  border: 0;\r\n  background: #d8d8d8;\r\n}\r\n.video-btn .btn:active {\r\n  border: 0;\r\n  background: #d8d8d8 !important;\r\n}\r\n.video-btn .btn img {\r\n  width: 24px;\r\n}\r\n.video-btn-bottom {\r\n  margin-top: 30px;\r\n}\r\n.video-btn-bottom .nav {\r\n  justify-content: space-between;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: space-between;\r\n}\r\n.video-btn .btn-end-call {\r\n  color: #FFF;\r\n  background: #E87373;\r\n}\r\n.video-btn .btn-end-call:hover {\r\n  background: #ad3434;\r\n}\r\n.video-btn .btn-end-call:active {\r\n  border: 0;\r\n  background: #ad3434 !important;\r\n}\r\n.incoming-call-notification {\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  border-radius: 15px;\r\n  background: white;\r\n  padding: 20px 20px 15px;\r\n  border: 1px solid #ccc;\r\n  z-index: 1000;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n.incoming-call-notification .btn {\r\n  font-size: 14px;\r\n  padding: 6px 24px;\r\n  margin: 5px;\r\n}\r\n.vitals-play-grid {\r\n  background: #CCCCCC;\r\n  border-radius: 30px;\r\n  width: 200px;\r\n  padding: 5px 15px;\r\n}\r\n.vitals-play-grid .nav {\r\n  justify-content: space-between;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: space-between;\r\n}\r\n.vitals-play-grid .nav li {\r\n  display: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n  margin-right: 10px;\r\n}\r\n.vitals-play-grid .nav li:last-child {\r\n  margin-right: 0;\r\n}\r\n.vitals-play-grid .nav li a {\r\n  color: #000;\r\n}\r\n.vitals-play-grid .nav li a::after {\r\n  display: none;\r\n}\r\n.vitals-play-grid .nav li p {\r\n  font-size: 14px;\r\n  background: transparent;\r\n  border-radius: 0;\r\n  padding: 0;\r\n  margin-bottom: 0;\r\n}\r\n.vitals-play-grid .nav li .play-bar {\r\n  width: 75px;\r\n  height: 3px;\r\n  border-radius: 30px;\r\n  background: #000;\r\n  display: inline-block;\r\n}\r\n.p-hour-picker .p-link {\r\n  font-size: 14px;\r\n}\r\n.p-minute-picker .p-link {\r\n  font-size: 14px;\r\n}\r\n.p-datepicker .p-timepicker span {\r\n  font-size: 14px;\r\n  color: #000;\r\n}\r\n.scrollable-div {\r\n  overflow-y: scroll;\r\n  width: 100%;\r\n}\r\n.circular-progress {\r\n  position: relative;\r\n  width: 105px;\r\n  height: 105px;\r\n}\r\n.circular-progress svg {\r\n  transform: rotate(-90deg);\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.circular-progress circle {\r\n  fill: none;\r\n  stroke-width: 4px;\r\n}\r\n.circular-progress .bg {\r\n  stroke: #e6e6e6;\r\n}\r\n.circular-progress .progress {\r\n  stroke: #007bff;\r\n  stroke-linecap: round;\r\n  stroke-dasharray: 307;\r\n  stroke-dashoffset: 307;\r\n  transition: stroke-dashoffset 0.5s ease;\r\n}\r\n.circular-progress .percentage {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 16.8px;\r\n  font-weight: bold;\r\n}\r\n.checkduration .form-check input {\r\n  cursor: pointer;\r\n}\r\n.prescription-details-info .prescription-info {\r\n  width: 28%;\r\n}\r\n.join-body {\r\n  overflow: hidden;\r\n}\r\n.join-scroll-right {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 4px;\r\n}\r\n.join-body .modal-backdrop {\r\n  background-color: #0000001c;\r\n}\r\n.prescription-form-top {\r\n  margin-top: 24px;\r\n}\r\n.screenshot-details .prescription_preview_btn {\r\n  padding: 6px 24px;\r\n  color: #FFF;\r\n}\r\n.screenshot-details .prescription_preview_btn:hover {\r\n  color: #3FA2DB;\r\n}\r\n.screenshot-details .prescription_preview_btn:after {\r\n  display: none;\r\n}\r\n.iframe-btn .btn {\r\n  padding: 6px 24px;\r\n}\r\n.patient-nav-list .nav li:nth-child(5) {\r\n  border: 0;\r\n}\r\n.patient-nav-list .nav li:last-child {\r\n  margin-left: auto;\r\n}\r\n.pacs-modal-body .pacs-img img {\r\n  width: 100%;\r\n}\r\n.vitals-head {\r\n    margin-bottom: 15px;\r\n}\r\n.vitals-body-info {\r\n    padding-left: 40px;\r\n    padding-right: 15px;\r\n}\r\n.vitals-body-info hr {\r\n  opacity: 1;\r\n  border-top: 1px solid #E6E6E6;\r\n}\r\n.card .vitals-patient-card-body {\r\n\tpadding: 30px 30px 20px;\r\n}\r\n.vitals-patient-list .nav {\r\n\t-webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n\tflex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n}\r\n.vitals-patient-list .nav li {\r\n\tfont-weight: 300;\r\n\tmargin-bottom: 10px;\r\n\tmargin-right: 50px;\r\n}\r\n.vitals-patient-list .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.vitals-patient-list .nav li span {\r\n\tfont-weight: 500;\r\n\tmargin-right: 5px;\r\n}\r\n.card.vitals-video-card {\r\n\tbackground: #E8E8E8;\r\n}\r\n.doctor-header.vitals-doctor-header {\r\n\tpadding-top: 0;\r\n\tpadding-bottom: 5px;\r\n}\r\n.prescription-table.prescription-table-info {\r\n\tmargin-bottom: 0;\r\n}\r\n.prescription-table.prescription-table-info .table thead tr th {\r\n\ttext-align: left;\r\n}\r\n.prescription-table.prescription-table-info .table thead tr th:first-child {\r\n\tpadding-left: 15px;\r\n}\r\n.prescription-table.prescription-table-infos .table tbody tr {\r\n  border-bottom: 0;;\r\n}\r\n.prescription-table.prescription-table-info .table tbody tr td {\r\n\tcolor: #000;\r\n\ttext-align: left;\r\n}\r\n.prescription-table.prescription-table-info .table tbody tr td:first-child {\r\n\tpadding-left: 15px;\r\n}\r\n.press-btn {\r\n\tmargin-bottom: 24px;\r\n}\r\n.press-btn .btn {\r\n\tpadding: 8px 24px;\r\n}\r\n\r\n@media (max-width: 1599.98px) {\r\n  .calendar-btn .btn {\r\n    padding: 7px 30px;\r\n  }\r\n}\r\n@media (max-width: 1199.98px) {\r\n  .video-container {\r\n    height: 500px;\r\n  }\r\n}\r\n@media (max-width: 575.98px) {\r\n  .calendar-btn {\r\n    padding-bottom: 10px;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n\r\n.video-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.main-screen {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.small-video-wrapper {\r\n  position: absolute;\r\n  bottom: 10px;\r\n  right: 10px;\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.small-screen {\r\n  width: 150px;\r\n  height: 100px;\r\n  border: 1px solid #ccc;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
